import React from "react";
import { Card } from "rebass";
import { NavLinkProps } from "react-router-dom";
import { IconBaseProps } from "react-icons";

import { StyledNavLink } from "./StyledNavLink";

interface IProps extends Pick<NavLinkProps, "to" | "isActive"> {
  Icon: React.ComponentType<IconBaseProps>;
  title: string;
  color: string;
}

export const NavLink: React.FC<IProps> = ({ to, isActive, Icon, title, color }) => (
  <StyledNavLink to={to} isActive={isActive}>
    <Card
      flex="0 0 auto"
      p="2px"
      backgroundColor={color}
      borderRadius="7px"
      css="overflow: hidden;"
    >
      <Icon size={26} fill="white" display="block" />
    </Card>

    <span>{title}</span>
  </StyledNavLink>
);
